// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/fontawesome/css/all.min.css
// module id = ktSS
// module chunks = 1